module.exports = __webpack_public_path__ + "static/og_image-84be2f2d8bb790e984519a93ab26083a.jpg";